import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  CustomResultOfPaginatedListOfPlanListItemDto,
  GetEnumValuesDto,
  PlanListItemDto,
  PlanMenusDto,
} from 'src/app/core/api/models';
import { PlansService } from 'src/app/core/api/services';
import { FormPageConfig } from 'src/app/core/models/form-page-config.model';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { CustomClaimDto } from '../../system-management/roles/models/custom-claim-dto';
import { CustomMenuDto } from '../../system-management/roles/models/custom-menu-dto';
import { MenuClaimDto } from './../../../core/api/models/menu-claim-dto';
import { PaginatedListOfPlanListItemDto } from './../../../core/api/models/paginated-list-of-plan-list-item-dto';
import { EventTypes } from './../../../core/constants/event-types';

@Component({
    selector: 'app-plans-management',
    templateUrl: './plans-management.component.html',
    styleUrls: ['./plans-management.component.scss'],
    standalone: false
})
export class PlansManagementComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = 'plans';
  protected currentService = inject(PlansService);
  paginationApiMethodName: string = this.currentService.plansGetPlansWithPagination.name;
  deleteApiMethodName: string = this.currentService.plansDelete.name;
  auditApiMethodName: string = this.currentService.plansGetPlansAudit.name;
  modelWithPagination$: Observable<PaginatedListOfPlanListItemDto>;
  items$: Observable<Array<PlanListItemDto>>;
  formPageConfig: FormPageConfig<PlanMenusDto> = {};
  PlanTypeEnumValues: GetEnumValuesDto[] = [];
  menus: Array<CustomClaimDto> = []; // for create and edit plan
  //#endregion

  constructor() {
    super();
  }

  ngOnInit(): void {
    try {
      super.ngOnInit();
      this.pageConfig.isAddBtnWithLoading = true;
      this.pageConfig.title = this.pageVocabs + 'plansManagementTitle';
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.plans);
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('PlanType')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.PlanTypeEnumValues = values));
  }

  configTableColumns(): void {
    this.tableColumns = [
      {
        title: this.localizer.id,
        name: 'id',
        hasSearch: true,
        type: 'number',
        noNumberSeparator: true,
      },
      { title: this.localizer.name, name: 'name', hasSearch: true },
      {
        title: `${this.tableVocabs}planType`,
        name: 'planType',
        hasSearch: true,
        type: 'enum',
        enumName: 'PlanType',
      },
      {
        title: this.localizer.price,
        name: 'price',
        needCurrency: true,
        hasSearch: true,
        type: 'number',
      },
      {
        title: this.localizer.default,
        name: 'isDefault',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.expireDate,
        name: 'expirationTime',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  createGetApi() {
    this.unSubs();
    this.loading = true;

    this.currentService
      .plansCreateGet({})
      .pipe(this.basePipeOperators())
      .subscribe((items) => {
        this.menus = items.data;
        this.menus = this.mapMenus(this.menus);
        this.formPageConfig.isEditMode = false;
        this.pageConfig.isVisibleForm = true;
      });
  }


  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;
    this.formPageConfig.editId = id;

    this.currentService
      .plansUpdateGet({ id: id })
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        this.menus = this.mapMenus(this.menus);
        this.formPageConfig.editData = res.data;
        this.formPageConfig.isEditMode = true;
        this.pageConfig.isVisibleForm = true;
      });
  }

  //#endergion

  mapMenus(menus: MenuClaimDto[]): MenuClaimDto[] {
    try {
      const visibleMenuClaims = (menus: CustomMenuDto[]) =>
        menus.forEach((menu) => {
          menu.isVisible = true;

          if (menu.claims?.length)
            menu.claims.map((claim) => (claim.isVisible = true));

          if (menu.subMenus?.length) visibleMenuClaims(menu.subMenus);
        });

      visibleMenuClaims(menus);
      return menus;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }
}
